import { useTranslation } from "react-i18next";
import { Markup } from 'interweave';
import { useState } from 'react';

export default function WhoWeAre(){
    const { t } = useTranslation();
    const [showVideo, setShowVideo] = useState(false);

    const handleVideoClick = () => {
        setShowVideo(prev=>!prev);
    };
    return (
        <article id="aboutus">
            <section class="about-us">
                <div class="container content-wrapper">
                    <div class="row">
                        <div class="col-sm-12 col-md-5">
                            <div class="graphic-container">
                                <div className="graphics"></div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-7">
                            <div class="section-highlight">{t('home.whoweare.section_title')}</div>
                            <div class="section-title">
                                <h4>{t('home.whoweare.title')}</h4>
                            </div>
                            <div>
                                <Markup content={t('home.whoweare.intro')}></Markup>
                            </div>
                            <div className="brand-video"><b><a href="#video-section" onClick={handleVideoClick}>{!showVideo ? 'Celebrating People, Culture & Innovation – Watch here' : 'Click to Hide'}</a></b></div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="video-section">
            {showVideo && (
                    <div className="container">
                        <div className="row">
                            <div className="col">
                            {/* <iframe width="100%" style={{aspectRatio : "16/9"}} src="https://www.youtube.com/embed/4ddoR4AsJOk?autoplay=1&controls=1&modestbranding=1&showinfo=0&rel=0" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe> */}
                            {/* <embed width="100%" style={{aspectRatio : "16/9"}} src="https://www.youtube.com/embed/4ddoR4AsJOk?autoplay=1" type="video/mp4" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></embed> */}
                            {/* <video src="https://www.youtube.com/embed/4ddoR4AsJOk" preload="auto" controls autoPlay style={{width: "100%", height: "100%"}}></video> */}
                            <iframe width="100%" style={{aspectRatio : "16/9"}} src="https://www.youtube.com/embed/4ddoR4AsJOk?autoplay=1&controls=1&modestbranding=1&showinfo=0&rel=0" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                        </div>
                        
                    </div>
                )}
            </section>
        </article>
    )
}